import { type SuburbType } from '@discover-data/gql/fragments/suburb';

export default function isValidSuburb(suburb: SuburbType | null, options: SuburbType[]): boolean {
  return suburb === null || !!options.find(({ id }) => id === suburb.id);
}
